export type RoleType = Partial<{
	id: string;
	name: string;
	description: string;
	createdAt: string;
	updatedAt: string;
	createRequestId: string;
	updateRequestId: string;
}>;

export const getRoleBadgeColor = (role: string) => {
	switch (role) {
		case 'Administrator':
			return 'bg-purple-50 text-purple-700 border-purple-200';
		case 'Asset Manager':
			return 'bg-green-50 text-green-700 border-green-200';
		case 'Inspection Manager':
			return 'bg-blue-50 text-blue-700 border-blue-200';
		case 'Inspection Viewer':
			return 'bg-cyan-50 text-cyan-700 border-cyan-200';
		case 'Work Package Manager':
			return 'bg-orange-50 text-orange-700 border-orange-200';
		case 'Work Package Viewer':
			return 'bg-amber-50 text-amber-700 border-amber-200';
		case 'Monitoring Viewer':
			return 'bg-teal-50 text-teal-700 border-teal-200';
		default:
			return 'bg-zinc-50 text-zinc-700 border-zinc-200';
	}
};
